module.exports = __webpack_public_path__ + "media/images/emblems/Zullwil-blason-030340433f52bff2449ee221be62bf51.png";